import { render, staticRenderFns } from "./BasicFooter.vue?vue&type=template&id=fcb93374&scoped=true"
import script from "./BasicFooter.vue?vue&type=script&lang=js"
export * from "./BasicFooter.vue?vue&type=script&lang=js"
import style0 from "./BasicFooter.vue?vue&type=style&index=0&id=fcb93374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_65b20228bf64a20fbf49a510659098cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb93374",
  null
  
)

export default component.exports